import styled from 'styled-components';
import { GlobalToken } from 'antd';

export interface ContainerProps {
  theme: { token: GlobalToken };
  $isLoading: boolean;
}

export const Container = styled.div<ContainerProps>`
  padding-top: ${({ theme: { token } }) => token.paddingSM}px;

  .action-bar {
    .action-bar-item {
      margin: 0 ${({ theme: { token } }) => token.marginXXS}px;

      &.vs {
        margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      }

      .ant-picker.range-picker2 {
        input[disabled] {
          opacity: 0.5;
        }
      }

      &.export-btn {
        width: 36px;
        height: 36px;
        padding: ${({ theme: { token } }) => token.paddingSM}px;

        &:hover {
          path {
            fill: ${({ theme: { token } }) => token.colorText};
          }
        }

        &:active {
          path {
            fill: ${({ theme: { token } }) => token.colorPrimary};
          }
        }
      }
    }

    .label-range {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
    }
  }

  .graph-container {
    display: flex;
    position: relative;
    margin-top: ${({ theme: { token } }) => token.marginMD}px;
    margin-left: ${({ theme: { token } }) => token.marginSM}px;

    .graph-view {
      position: relative;
      flex-grow: 1;

      .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 1;

        .anticon-loading {
          font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
        }
      }
    }

    .map-legend {
      flex: 0 0 220px;
      padding-left: ${({ theme: { token } }) => token.paddingXL}px;

      ul {
        li {
          position: relative;
          margin-bottom: ${({ theme: { token } }) => token.marginSM}px;

          .bullet {
            position: absolute;
            top: 6px;
            left: -15px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
          }

          .title {
            font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
          }

          .date {
            font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
            color: ${({ theme: { token } }) => token.colorTextSecondary};
          }
        }
      }
    }

    [data-highcharts-chart] {
      flex-grow: 1;
      ${({ $isLoading }) => ($isLoading ? 'opacity: 0.5;' : '')};
      transition: opacity 0.5s ease;

      .highcharts-axis-title {
        margin-left: -${({ theme: { token } }) => token.marginXXL}px !important;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px !important;
      }
    }
  }

  .explainer {
    display: flex;
    align-items: center;
    margin-top: ${({ theme: { token } }) => token.marginSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;

    .icon-explainer {
      margin-right: ${({ theme: { token } }) => token.marginXXS}px;

      path {
        fill: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }

  .tabular-container {
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;
  }
`;
